import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=5c3fd911&scoped=true&"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js&"
import style1 from "./InvoiceDetails.vue?vue&type=style&index=1&id=5c3fd911&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3fd911",
  null
  
)

export default component.exports